var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcono2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 160,
    viewBox: "0 0 159 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.625 0C44.9387 0 47.625 2.68629 47.625 6V139.381L72.9871 113.776C75.3191 111.421 79.118 111.403 81.4723 113.735C83.8266 116.067 83.8448 119.866 81.5129 122.22L45.8879 158.187C44.761 159.325 43.2262 159.965 41.625 159.965C40.0238 159.965 38.489 159.325 37.3621 158.187L1.73713 122.22C-0.594788 119.866 -0.576634 116.067 1.77768 113.735C4.132 111.403 7.93094 111.421 10.2629 113.776L35.625 139.381V6C35.625 2.68629 38.3113 0 41.625 0ZM107.193 69.964H96.0112L121.136 0.145832H133.307L158.432 69.964H147.25L140.867 51.4867H113.587L107.193 69.964ZM127.511 12.8276L137.805 42.6231H116.655L126.966 12.8276H127.511ZM102.488 152.941V159.964H152.398V150.896H115.375L152.091 97.1686V90.1458H102.182V99.214H139.204L102.488 152.941Z",
    fill: "#ED3747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono2);
export default __webpack_public_path__ + "static/media/Icono2.8a5c840306581383785c4d2ff4e0f9ab.svg";
export { ForwardRef as ReactComponent };